import Blank from "@/layouts/blank.vue";
import DraftTripList from "@/pages/admin/draft-trip/DraftTripList.vue";
import DraftTripDetails from "@/pages/admin/draft-trip/DraftTripDetails.vue";

const draftTripRoutes = [
  {
    path: "draft-trip",
    name: "app-admin-draft-trip",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/draft-trip/list",
      },
      {
        path: "list",
        name: "app-admin-draft-trip-list",
        component: DraftTripList,
      },
      {
        path: "details/:id",
        name: "app-admin-draft-trip-details",
        component: DraftTripDetails,
      },
    ],
  },
];

export default draftTripRoutes;
